<template>
	<div id="compatibility-page">

		<div class="cv-rounded">

            <div class="w-100 d-md-none">
				<img src="@/assets/banners-clave-verde/optmized/BannerCompatibilidad600x350.jpg" alt="Compatibilidad" class="img-fluid w-100" />
            </div>
    
            <div class="w-100 d-none d-md-block d-lg-none">
                <img src="@/assets/banners-clave-verde/optmized/BannerCompatibilidad700x250.jpg" alt="Compatibilidad" class="img-fluid w-100">
            </div>
			
            <div class="w-100 d-none d-lg-block">
				<img src="@/assets/banners-clave-verde/optmized/BannerCompatibilidad1920x300.jpg" alt="Compatibilidad" class="img-fluid w-100">
            </div>

        </div>

		<section class="container content-section mt-4">
			<div class="row">
				<div class="col-lg-10 text-justify offset-lg-1">
					<p>
						Para que nuestra red funcione de manera adecuada, se requiere contar con equipos
						compatibles.<br />
						Todos los equipos que han sido importados de forma legal a nuestro país por decreto federal
						cuenta con la frecuencia 700 mhz que opera sobre la banda 28, la cual usará <b>Clave Verde</b>.
					</p>
					<ul class="pl-3">
						<li>Un equipo es compatible cuando opera sobre la banda 28, con una frecuencia de 700mhz.</li>
						<li>Cuenta con tecnología VoLTE.</li>
					</ul>
				</div>

				<router-view></router-view>

			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
}
</script>
